import classNames from "classnames";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";
import React, { useState } from "react";
import { ConflictingShowCard } from "./ShowCard";
import { ExclusivityCheckProblemMessage, NoConflictsMessage } from "./ExclusivityClauseMessages";

interface ConflictingShowsListProps {
  headerLabel: string
  noConflictsLabel: string
  includeClause: boolean
  conflictingShows: server.dto.ConflictingShow[]
  startDisplay: moment.Moment
  problems: server.dto.ExclusivityCheckProblems[]
}

const ConflictingShowsList = (props: ConflictingShowsListProps) => {
  const [phase, setPhase] = useState<server.dto.AppointmentPhases | null>(null);

  const phaseSelected = (filter: server.dto.AppointmentPhases) => {
    if (phase === filter) {
      setPhase(null);
    } else {
      setPhase(filter);
    }
  };

  const optionsClassSchedule = classNames("icon-option", {
    s1_transparent: phase === "option"
  });

  const confirmClassSchedule = classNames("icon-confirmed", {
    s1_transparent: phase === "confirmed"
  });

  const hasConflicts = props.conflictingShows.length > 0;
  const filteredConflicts = props.conflictingShows.filter(conflict => conflict.appointmentPhase !== phase);

  if (props.problems.length > 0) {
    return <>
      <div className="flex">
        <div className="grow1">
          <h2>{props.headerLabel}</h2>
        </div>
      </div>
      <div>
        <ExclusivityCheckProblemMessage problems={props.problems} />
      </div>
    </>
  }

  return <>
    <div className="flex">
      <div className="grow1">
        <h2>{props.headerLabel}</h2>
      </div>
      {hasConflicts && <>
        <div key="scheduleOption" className="margin-right-small">
          <a className={optionsClassSchedule} onClick={() => phaseSelected("option")}></a>
        </div>
        <div key="scheduleConfirm">
          <a className={confirmClassSchedule} onClick={() => phaseSelected("confirmed")}></a>
        </div>
      </>}
    </div>
    <div style={{ overflow: "auto", overflowX: "hidden" }}>
      {!hasConflicts && <NoConflictsMessage>{props.noConflictsLabel}</NoConflictsMessage>}
      {filteredConflicts
        .map(conflict =>
          <ShowSidePanel
            canEdit
            key={conflict.showId}
            showId={conflict.showId}
            trigger={
              <ConflictingShowCard
                isSelected={false}
                key={conflict.showId}
                show={conflict}
                clause={props.includeClause ? conflict.exclusivityClause : null}
                compareToShowDate={props.startDisplay}
                className="margin-bottom-small"
              />
            }
          />
        )}
    </div>
  </>
}

export const ExclusivityConflictShowList = (props: Omit<ConflictingShowsListProps, "headerLabel" | "includeClause">) => {

  return <ConflictingShowsList
    headerLabel={RESX.Exclusivity.ExclusivityConflicts}
    includeClause
    {...props}
  />
}

export const ScheduleConflictShowList = (props: Omit<ConflictingShowsListProps, "headerLabel" | "includeClause">) => {
  if (!site.userPreference.display.displayScheduleConflicts) {
    return null;
  }

  return <ConflictingShowsList
    headerLabel={RESX.Exclusivity.ScheduleConflicts}
    includeClause={false}
    {...props}
  />
}